<template>
  <div>
    <PageAllow controller="StockMaterials" action="index" />
    <Breadcrumbs :items="items" />
    <v-slide-x-transition>
      <v-sheet class="transparent-background-color">
        <v-row dense class="mx-5">
          <v-col cols="12" sm="12" md="4">
            <v-row dense align="center" class="pa-1">
              <!-- 商品 -->
              <SearcherMaterials
                v-model="materialSelected"
                :material-categories="materialCategories"
              />
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="8" align-self="center">
            <v-row dense align="center" class="search-controls">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="px-0 py-0 caption font-weight-bold grey--text"
                    color="primary"
                    @click.stop="onSearch()"
                  >
                    <v-icon small class="pe-1">fa-search</v-icon>
                    {{ $t("Search.search") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.searchTip") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="caption font-weight-bold grey--text"
                    @click.stop="resetSearch()"
                  >
                    <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                    {{ $t("Search.reset") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.resetTip") }}</span>
              </v-tooltip>
              <v-divider vertical />
              <v-btn
                class="caption font-weight-bold grey--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
                small
                text
                @click.stop="$store.commit('toggleSearchPanel')"
              >
                {{ $t("Search.pro") }}
                <v-icon small class="ps-1">{{
                  $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
                }}</v-icon>
              </v-btn>
              <v-spacer />
              <!-- 一键期初 -->
              <v-btn
                small
                color="primary"
                class="px-2 me-2 mb-1"
                @click.stop="editInitialize()"
                v-if="
                  !is_initialize &&
                  $permission.permissionAllow('StockMaterials', 'initialize')
                "
              >
                {{ $t("CurrentStocks.editInitialize") }}
              </v-btn>
              <!-- 期初入库 -->
              <v-btn
                small
                color="primary"
                class="px-2 me-2 mb-1"
                @click.stop="$router.push('/current-stocks/initialize')"
                v-if="
                  !is_initialize &&
                  $permission.permissionAllow('StockMaterials', 'initialize')
                "
              >
                <v-icon x-small class="pe-1">fa-plus</v-icon>
                {{ $t("CurrentStocks.stockInitializeStockIn") }}
              </v-btn>
              <!-- 导出 -->
              <v-tooltip
                v-if="$permission.permissionAllow('StockMaterials', 'export')"
                top
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    v-bind="attrs"
                    v-on="on"
                    dark
                    color="print"
                    class="px-2 me-2 mb-1"
                    @click.stop="exportExcel()"
                  >
                    <v-icon x-small class="pe-1">fa-file-excel</v-icon>
                    {{ $t("CurrentStocks.Fields.export") }}
                  </v-btn>
                </template>
                <span>{{ $t("CurrentStocks.Fields.export") }}</span>
              </v-tooltip>
            </v-row>
          </v-col>
        </v-row>
        <v-expansion-panels
          v-model="$store.getters.panels"
          multiple
          flat
          accordion
        >
          <v-expansion-panel class="transparent-background-color">
            <v-expansion-panel-content>
              <v-row dense align="center">
                <!-- 商品分类 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherMaterialCategory
                    v-model="materialCategorySelected"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <SearcherKeyword
                    ref="keyword"
                    v-model="options.keyword"
                    @text="keyword = $event"
                    :label="$t('CurrentStocks.keyword')"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <SearcherSelect
                    ref="brand"
                    v-model="options.brand"
                    :items="material_brands"
                    :label="$t('Material.Fields.brand')"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <SearcherStatus
                    v-model="options.raw_material_flg"
                    :label="$t('CurrentStocks.rawMaterial.title')"
                    :items="$consts.stockMaterialsIsRaw"
                  />
                </v-col>
                <!-- 是否零库存商品 -->
                <v-col cols="12" sm="6" md="4">
                  <div
                    class="caption grey--text input-chip-group-label"
                    :class="
                      $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                    "
                  >
                    {{ $t("CurrentStocks.zeroStatus.title") }}
                  </div>
                  <v-radio-group row v-model="options.inventory_type">
                    <v-radio
                      :label="$t('CurrentStocks.zeroStatus.all')"
                      :key="1"
                      :value="1"
                    />
                    <v-radio
                      :label="$t('CurrentStocks.zeroStatus.on')"
                      :key="2"
                      :value="2"
                    />
                    <v-radio
                      :label="$t('CurrentStocks.zeroStatus.off')"
                      :key="3"
                      :value="3"
                    />
                    <v-radio
                      :label="$t('CurrentStocks.zeroStatus.zero')"
                      :key="4"
                      :value="4"
                    />
                  </v-radio-group>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <!-- 表格 -->
        <div class="mx-4 mb-4">
          <v-data-table
            :headers="headers"
            :items="stock_currents"
            :options.sync="options"
            :loading="loading"
            :page.sync="paging.page"
            :server-items-length="paging.count"
            multi-sort
            class="elevation-1 px-4 pt-1 sticky-table"
            id="sticky-table"
            :class="stickTableCols ? 'sticky-first-col sticky-last-col' : ''"
            fixed-header
            :footer-props="$t('$config.footer-props')"
          >
            <template v-slot:header.actions="{ header }">
              {{ header.text }}
              <v-icon x-small>fa-sliders-h</v-icon>
            </template>
            <!-- 均价 -->
            <template v-slot:item.average_price="{ item }">
              {{ $t("Global.money") }}
              {{ item.average_price | formatMoney }}
            </template>

            <template v-slot:item.category_name="{ item, index }">
              <span
                class="text-no-wrap"
                :v-resize="!index ? $stickTableResizer() : null"
              >
                {{ item.category_name }}
              </span>
            </template>
            <template v-slot:item.material_name="{ item }">
              <span class="text-no-wrap">
                {{ item.material_name }}
              </span>
            </template>
            <template v-slot:item.standard_name="{ item }">
              <span
                v-if="item.standard_name && item.standard_name.length > 12"
                :title="item.standard_name"
                style="cursor: pointer"
                class="text-no-wrap"
              >
                {{ item.standard_name.slice(0, 12) + "......" }}
              </span>
              <span v-else class="text-no-wrap">
                {{ item.standard_name }}
              </span>
            </template>
            <template v-slot:item.material_code="{ item }">
              <span class="text-no-wrap">
                {{ $t("CurrentStocks.material_code", [item.material_code]) }}
              </span>
            </template>
            <template v-slot:item.current_count="{ item }">
              <span class="text-no-wrap">
                {{ item.current_count ? item.current_count : 0 }}{{ item.unit }}
                <span
                  v-if="
                    item.stock_min > item.current_count &&
                    item.stock_min != null
                  "
                  class="red--text"
                  >{{ $t("CurrentStocks.Fields.min") }}
                </span>
                <span
                  v-if="
                    item.stock_max < item.current_count &&
                    item.stock_max != null
                  "
                  class="red--text"
                  >{{ $t("CurrentStocks.Fields.max") }}
                </span>
              </span>
            </template>
            <!-- 格式化金额 -->
            <template v-slot:item.total_price="{ item }">
              {{ $t("Global.money") }}{{ item.total_price | formatMoney }}
            </template>
            <template v-slot:item.batch_total_price="{ item }">
              {{ $t("Global.money") }}{{ item.batch_total_price | formatMoney }}
            </template>
            <!-- 低库存预警 -->
            <template v-slot:item.stock_min="{ item }">
              <span
                v-if="
                  stockMin &&
                  stockChange.id == item.id &&
                  $permission.permissionAllow('StockMaterials', 'edit')
                "
              >
                <v-text-field
                  v-model="stock_min"
                  single-line
                  dense
                  :placeholder="
                    item.stock_min || item.stock_min == 0
                      ? String(item.stock_min)
                      : ''
                  "
                  type="number"
                  min="0"
                  @blur="
                    stockMin = false;
                    stock_min = null;
                    getCurrentStocksFromAPI();
                  "
                  style="max-width: 80px; margin-left: auto"
                  v-on:keyup.enter="
                    saveMinStock();
                    stockMax = false;
                    stockMin = false;
                    stock_min = null;
                  "
                  :hint="$t('CurrentStocks.Fields.hint')"
                />
              </span>
              <span v-else>
                <a
                  @click.stop="
                    stockMin = true;
                    stockChange = item;
                  "
                >
                  <span v-if="item.stock_min == null">
                    {{ $t("CurrentStocks.Fields.unsetting") }}
                  </span>
                  <span v-else>
                    {{ item.stock_min }}
                  </span>
                </a>
              </span>
            </template>
            <!-- 高库存预警 -->
            <template v-slot:item.stock_max="{ item }">
              <span
                v-if="
                  stockMax &&
                  stockChange.id == item.id &&
                  $permission.permissionAllow('StockMaterials', 'edit')
                "
              >
                <v-text-field
                  v-model="stock_max"
                  single-line
                  dense
                  type="number"
                  min="0"
                  :placeholder="
                    item.stock_max || item.stock_max == 0
                      ? String(item.stock_max)
                      : ''
                  "
                  @blur="
                    stockMax = false;
                    stock_max = null;
                    getCurrentStocksFromAPI();
                  "
                  style="max-width: 80px; margin-left: auto"
                  v-on:keyup.enter="
                    saveMaxStock();
                    stockMax = false;
                    stockMin = false;
                    stock_max = null;
                  "
                  :hint="$t('CurrentStocks.Fields.hint')"
                />
              </span>
              <span v-else>
                <a
                  @click.stop="
                    stockMax = true;
                    stockChange = item;
                  "
                >
                  <span v-if="item.stock_max == null">
                    {{ $t("CurrentStocks.Fields.unsetting") }}
                  </span>
                  <span v-else>
                    {{ item.stock_max }}
                  </span>
                </a>
              </span>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-menu
                v-model="item.printBtnMenu"
                open-on-hover
                close-on-click
                close-on-content-click
                offset-y
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    dark
                    color="info"
                    class="px-2"
                    @click.stop=""
                  >
                    <v-icon x-small class="pe-1">fa-align-left</v-icon>
                    {{ $t("CurrentStocks.actions.details") }}
                    <v-icon x-small class="ps-1">
                      {{ item.printBtnMenu ? "fa-caret-up" : "fa-caret-down" }}
                    </v-icon>
                  </v-btn>
                </template>
                <v-list dense>
                  <!-- <v-list-item :href="'/#/current-stocks/' + item.material_id">
                    <v-list-item-title>
                      {{ $t("CurrentStocks.actions.stock_details") }}
                    </v-list-item-title>
                  </v-list-item> -->
                  <v-list-item
                    :href="'/#/stock-details?material_id=' + item.material_id"
                  >
                    <v-list-item-title>
                      {{ $t("CurrentStocks.actions.batch_details") }}
                    </v-list-item-title>
                  </v-list-item>
                  <!-- 出入库明细 -->
                  <v-list-item
                    :href="'/#/stock-order-analyze/' + item.material_id"
                  >
                    <v-list-item-title>
                      {{ $t("CurrentStocks.actions.in_out_details") }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
          </v-data-table>
        </div>
      </v-sheet>
    </v-slide-x-transition>
  </div>
</template>

<script>
import { mapState } from "vuex";
import PageAllow from "@/components/PageAllow";
import i18n from "@/i18n";
import Breadcrumbs from "@/components/Breadcrumbs";
import StockCurrents from "@/api/stock_materials";
import Shops from "@/api/shops";
import Stock from "@/api/stocks";
import SearcherMaterialCategory from "@/components/plugins/SearcherMaterialCategory";
import SearcherMaterials from "@/components/plugins/SearcherMaterials";
import SearcherStatus from "@/components/plugins/SearcherStatus";
import SearcherSelect from "@/components/plugins/SearcherSelect";
import Materials from "@/api/materials";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";

const defaultOptions = {
  status: [0, 1],
  district_ids: [],
  category_code: "",
  material_ids: [],
  inventory_type: 1,
  raw_material_flg: [0, 1],
  keyword: "",
};

export default {
  data: () => ({
    stock_currents: [],
    materialCategorySelected: null,
    materialSelected: [],
    material_brands: [],
    keyword: "",
    paging: {},
    options: JSON.parse(JSON.stringify(defaultOptions)),
    loading: false,
    stock_currents_total_num: 0,
    stock_currents_batch_total_num: 0,
    stock_currents_total_price: 0,
    stock_currents_batch_total_price: 0,
    stockMin: false,
    stockMax: false,
    stockChange: {},
    is_initialize: 1,
    stock_min: null,
    stock_max: null,
    materialCategories: [],
    // result:null
  }),
  components: {
    Breadcrumbs,
    PageAllow,
    SearcherMaterialCategory,
    SearcherMaterials,
    SearcherStatus,
    SearcherSelect,
    SearcherKeyword,
  },
  props: {
    detailMode: Boolean,
  },
  computed: {
    locale() {
      return this.$i18n.locale != "zhHans";
    },
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.stockManagement"),
        disabled: false,
        href: "/current-stocks",
      },
      {
        text: i18n.t("Nav.currentStocks"),
        disabled: true,
        href: "/current-stocks",
      },
    ],
    headers() {
      var headers = [
        {
          text: i18n.t("CurrentStocks.Fields.material_code"),
          align: "start",
          sortable: false,
          value: "material_code",
        },
        {
          text: i18n.t("CurrentStocks.Fields.material_name"),
          align: "start",
          sortable: false,
          value: "material_name",
        },
        {
          text: i18n.t("CurrentStocks.Fields.standard_name"),
          align: "center",
          sortable: false,
          value: "standard_name",
        },
        {
          text: i18n.t("CurrentStocks.Fields.material_category"),
          align: "start",
          sortable: false,
          value: "category_name",
        },
        {
          text: i18n.t("CurrentStocks.Fields.brand"),
          align: "center",
          sortable: false,
          value: "brand",
        },
        {
          text: i18n.t("CurrentStocks.Fields.unit"),
          align: "start",
          sortable: false,
          value: "unit",
        },
        {
          text: i18n.t("CurrentStocks.Fields.average_price"),
          align: "start",
          sortable: false,
          value: "average_price",
        },
        {
          text: i18n.t("CurrentStocks.Fields.current_count"),
          align: "start",
          sortable: false,
          value: "current_count",
        },
        {
          text: i18n.t("CurrentStocks.Fields.total_price"),
          align: "start",
          sortable: false,
          value: "total_price",
        },
        {
          text: i18n.t("CurrentStocks.Fields.stock_min"),
          align: "end",
          sortable: false,
          value: "stock_min",
        },
        {
          text: i18n.t("CurrentStocks.Fields.stock_max"),
          align: "end",
          sortable: false,
          value: "stock_max",
        },
        {
          text: i18n.t("CurrentStocks.Fields.actions"),
          align: "start",
          sortable: false,
          value: "actions",
        },
      ];
      return headers;
    },
    ...mapState(["accountSettings", "stickTableCols"]),
  },

  mounted() {
    Materials.fetchFiledSelects({
      field_names: ["brand"], // 暂时只用品牌查询，只做品牌的数据
    }).then(
      function (response) {
        if (response.data.status.isOK()) {
          this.material_brands = response.data.brand;
        }
      }.bind(this)
    );

    this.getLevelOneStock();
    this.$commonUtils
      .loadOptions("stock_currents", [
        "materialCategorySelected",
        "materialSelected",
      ])
      .then(
        function (data) {
          if (data.options) {
            this.options = data.options;
          } else this.resetSearch();
          data.selecteds.forEach((selected) => {
            switch (selected.key) {
              case "materialCategorySelected":
                this.materialCategorySelected = selected.value;
                break;
              case "materialSelected":
                this.materialSelected = selected.value;
                break;
            }
          });
        }.bind(this)
      );
  },
  methods: {
    onSearch() {
      // 搜索
      this.options = Object.assign({}, this.options, {keyword: this.keyword});
    },
    resetSearch() {
      this.materialCategorySelected = null;
      this.materialSelected = [];
      this.options = JSON.parse(JSON.stringify(defaultOptions));
      //重置搜索框
      let clearArr = [
        this.$refs.keyword,
      ];
      clearArr.forEach((k) => {
        if (k) k.clear();
      });
    },
    getCurrentStocksFromAPI() {
      this.loading = true;
      this.id = this.$route.query.stock_id;
      StockCurrents.fetch(this.options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.stock_currents = response.data.stock_materials.map(
              (stock_current) => {
                // 值为0等于未设置
                if (stock_current.stock_min == 0) {
                  stock_current.stock_min = null;
                }
                if (stock_current.stock_max == 0) {
                  stock_current.stock_max = null;
                }
                return stock_current;
              }
            );
            this.stock_currents_total_num =
              response.data.stock_currents_total_num;
            this.stock_currents_batch_total_num =
              response.data.stock_currents_batch_total_num;
            this.stock_currents_total_price =
              response.data.stock_currents_total_price;
            this.stock_currents_batch_total_price =
              response.data.stock_currents_batch_total_price;
            this.paging = response.data.paging;
          } else if (response.data.error.code.isNoResultSet()) {
            this.options.page = 1;
          }
          this.loading = false;
        }.bind(this)
      );
    },
    exportExcel() {
      StockCurrents.exports(this.options);
    },
    editInitialize() {
      Shops.editInitialize().then(
        function (response) {
          if (response.data.status.isOK()) {
            this.$snackbar.success(
              i18n.t("CurrentStocks.editInitializeSuccess")
            );
            this.$router.go(0);
          }
        }.bind(this)
      );
    },
    saveMinStock() {
      var submitData = {
        id: this.stockChange.id,
        stock_max: this.stockChange.stock_max,
        stock_min:
          this.stock_min == null ? this.stock_min : Number(this.stock_min),
      };
      StockCurrents.stockEdit(submitData).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.getCurrentStocksFromAPI();
          }
        }.bind(this)
      );
    },
    saveMaxStock() {
      var submitData = {
        id: this.stockChange.id,
        stock_max:
          this.stock_max == null ? this.stock_max : Number(this.stock_max),
        stock_min: this.stockChange.stock_min,
      };
      StockCurrents.stockEdit(submitData).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.getCurrentStocksFromAPI();
          }
        }.bind(this)
      );
    },
    getLevelOneStock() {
      Stock.getLevelOneStock().then(
        function (response) {
          if (response.data.status.isOK()) {
            this.is_initialize = response.data.stock.is_initialize;
          }
        }.bind(this)
      );
    },
  },
  watch: {
    options: {
      deep: true,
      handler() {
        this.getCurrentStocksFromAPI();
        sessionStorage.setItem(
          "stock_currents-options",
          JSON.stringify(this.options)
        );
      },
    },
    // 商品分类
    materialCategorySelected: {
      handler() {
        this.options.category_code = this.materialCategorySelected
          ? this.materialCategorySelected.code
          : "";
        sessionStorage.setItem(
          "stock_currents-materialCategorySelected",
          JSON.stringify(this.materialCategorySelected)
        );
        if (this.materialCategorySelected) {
          this.materialCategories = [this.materialCategorySelected];
        } else {
          this.materialCategories = [];
        }
      },
    },

    // 商品
    materialSelected: {
      handler() {
        this.options.material_ids = this.materialSelected
          ? this.materialSelected.map((e) => {
              return e.material_id;
            })
          : "";
        sessionStorage.setItem(
          "stock_currents-materialSelected",
          JSON.stringify(this.materialSelected)
        );
      },
    },
  },
};
</script>

<style>
</style>